import { BRAND } from "constants/brand";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import "./product.scss";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "utils/money";
const Product = (props) => {
    const navigate = useNavigate();
    return (
        <div className="col" style={{ padding: "10px" }}>
            <div className="product">
                <div className="fav-btn center" style={{ left: 0, right: "unset" }}>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={props.selectedProducts.includes(props.product.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                props.setSelectedProducts((prev) => [...prev, props.product.id]);
                            } else {
                                props.setSelectedProducts((prev) =>
                                    prev.filter((id) => id !== props.product.id),
                                );
                            }
                        }}
                    />
                </div>
                <div className="fav-btn center">
                    <DropDownButtons
                        delete={() => {
                            props.setSelectedProductValue(props.product);
                            props.toggleDelete();
                        }}
                        edit={() => {
                            navigate(props.product.id + "");
                        }}
                    />
                </div>
                <div className="image">
                    <img src={props.product?.productImages[0]?.image} alt="" />
                </div>
                <div className="product-info">
                    <h4>{props.product?.title}</h4>
                    <span style={{ fontSize: "13px" }}>المطعم: {props.product?.user?.name}</span>
                    <span style={{ margin: "0 5px", color: BRAND, fontWeight: "bold" }}>|</span>
                    <span style={{ fontSize: "13px" }}>القسم: {props.product?.category?.name}</span>
                    <div>
                        <span style={{ fontSize: "13px" }}>
                            ترتيب الظهور: {props.product?.order}
                        </span>
                    </div>
                    <div className="price-rate">
                        <div className="price">
                            <i
                                className="fa fa-tag"
                                style={{ fontSize: "lg", color: "#d9176f" }}
                            ></i>
                            <span>{formatMoney(props.product?.price)}</span>
                        </div>
                        <div className="rate">
                            <span>{props.product?.orders}طلب </span>
                            {props.product?.rating_count > 0 ? (
                                <span
                                    style={{
                                        color: "#f5a623",
                                        fontWeight: 600,
                                        marginInlineStart: "8px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    ★ {Number(props.product.rating_avg).toFixed(2)} (
                                    {props.product.rating_count})
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Product;
